<template>
  <SubRegistro :classe="classe">
    <Cabecalho
      tipo="porcentagem2"
      v-if="!registroSelecionado.blSimplesNacional"
      :titulo="alteracaoImportacao ? 'COFINS - Importação' : 'COFINS'"
      :aliquota="registroSelecionado.aliquota_cofins"
    />
    <Cabecalho
      tipo="porcentagem5"
      v-if="registroSelecionado.blSimplesNacional"
      :titulo="registroSelecionado.label_cofins"
      :aliquota="registroSelecionado.aliquota_cofins"
    />
    <div v-if="registroSelecionado.aliquota_cofins" class="separador" />

    <Cabecalho
      tipo="porcentagem2"
      v-if="registroSelecionado.red_aliquota_cofins"
      :titulo="
        `Redução da Base de Cálculo ${
          registroSelecionado.tipo_red_cofins ? registroSelecionado.tipo_red_cofins : ''
        }`
      "
      :aliquota="registroSelecionado.red_aliquota_cofins"
    />
    <div v-if="registroSelecionado.red_aliquota_cofins" class="separador" />
    <Cabecalho
      tipo="porcentagem2"
      v-if="registroSelecionado.red_aliquota_outra_cofins"
      :titulo="
        `Redução da Base de Cálculo ${
          registroSelecionado.tipo_red_cofins ? registroSelecionado.tipo_red_cofins : ''
        }`
      "
      :aliquota="registroSelecionado.red_aliquota_outra_cofins"
    />
    <div v-if="registroSelecionado.red_aliquota_outra_cofins" class="separador" />

    <Memoria :titulo="'Memória de cálculo:'" :memoria="registroSelecionado.memoria_cofins" />
    <Cabecalho
      v-if="!!registroSelecionado.adicional_aliquota_cofins"
      :titulo="'Adicional de Alíquota'"
      :aliquota="registroSelecionado.adicional_aliquota_cofins"
    />

    <div v-if="registroSelecionado.adicional_aliquota_cofins" class="separador" />

    <Memoria
      negrito
      v-if="registroSelecionado.red_aliquota_cofins"
      :memoria="this.baseDeCalculoCofins"
    />

    <div v-if="registroSelecionado.red_aliquota_cofins" class="separador" />

    <div
      v-if="
        (registroSelecionado.adicional_aliquota_cofins ||
          registroSelecionado.aliquota_efetiva_cofins ||
          registroSelecionado.label_cofins) &&
          registroSelecionado.label_cofins_excedente
      "
      class="separador"
    />

    <Cabecalho
      v-if="!!registroSelecionado.aliquota_efetiva_cofins"
      :titulo="'Alíquota Efetiva'"
      :aliquota="registroSelecionado.aliquota_efetiva_cofins"
    />
    <div
      v-if="!!registroSelecionado.aliquota_efetiva_cofins && registroSelecionado.aliquota_cofins"
      class="separador"
    />

    <Cabecalho
      tipo="porcentagem5"
      v-if="registroSelecionado.label_cofins_excedente"
      :titulo="registroSelecionado.label_cofins_excedente"
      :aliquota="registroSelecionado.aliquota_cofins_excedente"
    />
    <div v-if="registroSelecionado.label_cofins_excedente" class="separador" />
    <Memoria
      :titulo="'Memória de cálculo:'"
      :memoria="registroSelecionado.memoria_cofins_excedente"
    />

    <div v-if="registroSelecionado.memoria_cofins_excedente" class="separador" />

    <BaseLegal
      :modificador="' do Adicional de Alíquota'"
      :base_legal="registroSelecionado.base_legal_adicional_cofins"
      :classe="classe"
    />

    <div v-if="registroSelecionado.base_legal_adicional_cofins" class="separador" />

    <BaseLegal :base_legal="registroSelecionado.base_legal_cofins" :classe="classe" />
  </SubRegistro>
</template>

<script>
import BaseLegal from "@/components/BaseLegal/BaseLegal.vue";
import Cabecalho from "@/components/Cabecalho/Cabecalho.vue";
import Descricao from "@/components/Descricao/Descricao.vue";
import EditButton from "@/components/Button/EditButton.vue";
import Ncm from "@/components/Ncm/Ncm.vue";
import Notificacao from "@/components/Notificacao/Notificacao.vue";
import RadioButton from "@/components/Button/RadioButton.vue";
import Registro from "@/components/Registro/Registro.vue";
import Separador from "@/components/Fields/Separador/Separador.vue";
import SubRegistro from "@/components/SubRegistro/SubRegistro.vue";
import Memoria from "../Memoria/Memoria.vue";

export default {
  name: "RegistroCofins",
  components: {
    BaseLegal,
    Cabecalho,
    Descricao,
    EditButton,
    Notificacao,
    RadioButton,
    Registro,
    Separador,
    SubRegistro,
    Ncm,
    Memoria
  },
  props: { registroSelecionado: Object, classe: String },
  inject: ["alteracaoImportacao"],
  data() {
    return {
      baseDeCalculoCofins:
        "(Receita Bruta - % de Redução de Base de Cálculo) = Base de Cálculo <br> Base de Cálculo x Alíquota do COFINS = Valor do COFINS <br> (Valor do COFINS / Receita Bruta) x 100 = Alíquota Efetiva do COFINS"
    };
  }
};
</script>

<style lang="scss" scoped></style>
